import React, { useEffect, useRef, useState } from 'react'
import { Card, CardBody, CardHeader, CardText, CardTitle } from 'reactstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Auth } from 'aws-amplify'

import { appendOnboarding, setOnboardingInProgress, switchDarkMode, toggleDarkMode, toggleHeader, toggleSidebar } from '../../../features/session/sessionSlice'
import { deleteMetricSessionStorage } from '../../../features/metric/metricSlice';
import { useStyles } from '../../styles/OnboardingStyles'
import { parseTheme, serviceMap, defaultServiceMap, SITE_TOKEN_ONBOARDING_QUESTIONS, STEP_DICTIONARY_TPL } from '../../utils/common';

import SocialMedia from './Steps/SocialMedia';
import GoogleAnalytics from './Steps/GoogleAnalytics';
import DashboardQuestion from './Steps/DashboardQuestions'
import VideoPresentation from './Steps/VideoPresentation'

import logo from "../../../assets/images/insights-engine.png"
import { appendModel } from '../../../features/site/siteSlice';
import PaidAds from './Steps/PaidAds'
import Review from './Steps/Review'
import { updateSite } from '../../utils/Organizations'
import Customizations from './Steps/Customizations'
import Complete from './Steps/Complete'
import { updateUser } from '../../utils/Users'
import { client } from '../../utils/MQTT'
import OnboardingStepHeader from './Steps/OnboardingStepHeader'

function Onboarding(props){
    const nextBtnRef = useRef(null)
    const dispatch = useDispatch()
    const history = useHistory()

    const [STEP_DICTIONARY, setStepDictionary] = useState(STEP_DICTIONARY_TPL)

    const oauthTokens = useSelector(state => state.session.oauthTokens)
    const onboardingState = useSelector(state => state.session.onboarding)
    const model = useSelector(state => state.site.model)
    const user = useSelector(state => state.session.user)


    const classes = useStyles()
    const theme = parseTheme()
    // const serviceRef = useRef(null);

    useEffect(() => {
        dispatch(setOnboardingInProgress(true))
        dispatch(toggleSidebar(false))
        dispatch(toggleHeader(true))

        // Turn on light mode
        dispatch(toggleDarkMode(false))
        dispatch(switchDarkMode(false))
        
        return async() => {
            await dispatch(setOnboardingInProgress(false))
            await dispatch(toggleSidebar(true))
            await dispatch(toggleHeader(true))
    
            try {
                client?.disconnect();
            } catch(e){
                console.log(e)
            }
        }
    }, [])
    
    useEffect(() => {
        if(model?.siteActiveIdx !== -1){
            const currentSite = model?.sites?.length > 0 ? model?.sites[model?.siteActiveIdx] : {}
            const currentOrg = model?.organizations?.length > 0 ? model?.organizations[model?.orgActiveIdx] : {}

            try {
                client.subscribe(`onboarding/${currentSite.siteId}`)
            } catch(e){
                console.log(e)
            }

            if(import.meta.env.MODE === "production" && 
                (model.userSite?.type !== "SITE" ||
                !["onboarding", "evaluation"].includes(currentSite?.attr?.status ?? null))){

                history.push("/overview")
            }
            let accts = {}
            Object.keys(serviceMap).map(service => {
                let sItem = {}
                if(service === "ga"){
                    let hasGaLocal = false
                    
                    if(oauthTokens.ga?.id?.includes("ga4:") && localStorage.getItem(`ga4Selection`) !== null){
                        sItem = JSON.parse(localStorage.getItem(`ga4Selection`))
                        hasGaLocal = true
                    } else if(!oauthTokens.ga?.id?.includes("ga4:") && localStorage.getItem(`gaSelection`) !== null) {
                        sItem = JSON.parse(localStorage.getItem(`gaSelection`))
                        hasGaLocal = true
                    }

                    try {
                        accts[service] = JSON.parse(sItem.map)
                    } catch(e) {
                        // if(oauthTokens.ga && !oauthTokens.ga?.id?.includes("ga4:") && !sItem.view){
                        //     throw new Error("GA: no view id")
                        // }
                        localStorage.removeItem(`gaSelection`)
                        localStorage.removeItem(`ga4Selection`)
                    }
                    
                } else if(localStorage.getItem(`${service}Selection`) !== null){
                    sItem = JSON.parse(localStorage.getItem(`${service}Selection`))
                    try {
                        accts[service] = JSON.parse(sItem.map)
                    } catch(e) {
                        localStorage.removeItem(`${service}Selection`)
                    }
                }
            })
            dispatch(appendModel({
                siteForm: {
                    ...model.sites[model.siteActiveIdx],
                    attr: {
                        ...model.sites[model.siteActiveIdx].attr,
                        accounts: {
                            ...(model.sites[model.siteActiveIdx].attr?.accounts ?? {}),
                            ...accts
                        }
                    }
                }
            }))
            
            if(currentOrg?.attr?.token && SITE_TOKEN_ONBOARDING_QUESTIONS[currentOrg?.attr?.token]){
                dispatch(appendOnboarding({
                    qAndA: SITE_TOKEN_ONBOARDING_QUESTIONS[currentOrg?.attr?.token].questions.reduce((prev, curr, idx) => {
                        prev[`q${idx+1}`] = {
                            question: curr,
                            answer: ""
                        }

                        return prev
                    }, {})
                }))
            }
        }
    }, [model?.siteActiveIdx])

    useEffect(() => {
        if(props?.match?.params && Object.keys(props?.match?.params).length > 0 && onboardingState.step === 1){
            // const { model, oauthTokens } = props
            const { siteId, type } = props.match.params

            const site = model.sites[model.siteActiveIdx]

            if(["fbPage", "gmb", "linkedinOrg"].includes(type)){
                dispatch(appendOnboarding({
                    step: 2,
                    socialMediaService: type
                }))
            }

            if(["fb", "bing", "linkedin"].includes(type)){
                dispatch(appendOnboarding({
                    step: 3,
                    paidAdsService: type
                }))
            }

            if(["ga"].includes(type) && site?.attr?.accounts?.ga && site?.attr?.expediteOnboarding){
                dispatch(appendOnboarding({
                    step: 3
                }))
            }
        }
    }, [props?.match?.params])

    useEffect(() => {
        const site = model?.sites[model?.siteActiveIdx]
        if(!props?.match?.params && site?.attr?.accounts?.ga && onboardingState.step === 1){
            dispatch(appendOnboarding({
                step: site?.attr?.expediteOnboarding ? site?.attr?.status === "onboarded" ? 8 : 3 : 2
            }))
        }
    }, [model])

    useEffect(() => {
        if(onboardingState.step > 4 && onboardingState.metricsLoaded){
            const site = model.sites[model.siteActiveIdx]
            if(site?.attr?.expediteOnboarding && onboardingState.step < 8){
                dispatch(appendOnboarding({
                    step: 8
                }))
            } else if(!site?.attr?.expediteOnboarding && onboardingState.step < 6){
                dispatch(appendOnboarding({
                    step: 6
                }))
            }

            updateUser(null, {...user,  enableIntroTutorial: true})
            updateSite(site.siteId, null, {
                site:{
                    ...model.siteForm,
                    attr: {
                        ...model.siteForm.attr,
                        status: "onboarded"
                    }
                }
            })
            window.sessionStorage.setItem("onboarded", true)
        }
    }, [onboardingState])

    const site = model?.sites[model?.siteActiveIdx]
    const brand = model?.organizations[model?.orgActiveIdx]

    let QuestionsComponent = DashboardQuestion

    if(brand?.attr?.token && SITE_TOKEN_ONBOARDING_QUESTIONS[brand?.attr?.token]){
        QuestionsComponent = SITE_TOKEN_ONBOARDING_QUESTIONS[brand?.attr?.token].component
    }

    let logoDir = logo

    if(theme?.mainLogo){
        logoDir = theme.mainLogo
    }

    let nextEnabled = false
    let prevEnabled = false
    let nextText = "Next"

    switch(onboardingState.step){
        case 1:
            nextEnabled = (model?.siteForm?.attr?.accounts?.ga?.tokenId.includes("ga4:") && 
                model?.siteForm?.attr?.accounts?.ga?.propertyId)
            prevEnabled = false
        break;
        case 2:
            nextEnabled = (onboardingState.dontHaveIt.fbPage || model.siteForm?.attr?.accounts?.fbPage) &&
                (onboardingState.dontHaveIt.gmb || model.siteForm?.attr?.accounts?.gmb) &&
                (onboardingState.dontHaveIt.linkedinOrg || model.siteForm?.attr?.accounts?.linkedinOrg)
            prevEnabled = false
        break;
        case 3:
            nextEnabled = (onboardingState.dontHaveIt.fb || model.siteForm?.attr?.accounts?.fb) &&
                (onboardingState.dontHaveIt.bing || model.siteForm?.attr?.accounts?.bing) &&
                (onboardingState.dontHaveIt.linkedin || model.siteForm?.attr?.accounts?.linkedin)
            prevEnabled = true
        break;
        case 4:
            nextEnabled = true
            prevEnabled = true
            nextText = "Submit"
        break;
        case 5:
            nextEnabled = true
            prevEnabled = false
            nextText = site?.attr?.expediteOnboarding ? "Next" : "Finish"
        break;
        case 6:
            nextEnabled = Object.values(onboardingState.qAndA).reduce((prev, curr) => {
                if(curr.answer === ""){
                    prev = false
                }

                return prev
            }, true)

            nextText = site?.attr?.expediteOnboarding ? "Submit" : "Next"
        break;
        case 7:
            nextEnabled = onboardingState.videoEnded
            prevEnabled = false
        break;
        default:
        break;
    }

    if(nextEnabled && onboardingState.step <= 3){
        nextBtnRef.current?.focus()
    }

    return <div className={classes.container}>
        <OnboardingStepHeader />
        <div class="row no-gutters">
            <div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2 col-md-10 offset-md-1 col-sm-12">
                <Card className="onboarding-card d-flex flex-grow-1 align-items-center">
                    <CardBody className="">
                        {(onboardingState.step > 1 && 
                            ((site?.attr?.expediteOnboarding && onboardingState.step < 8) || (!site?.attr?.expediteOnboarding && onboardingState.step < 6))) && 
                            <h4 className="text-center mt-2 alert alert-info">
                                The page will automatically redirect when your site data is ready
                            </h4>}
                        <div>
                            {onboardingState.step === 1 && <GoogleAnalytics />}
                            {onboardingState.step === 2 && <SocialMedia />}
                            {onboardingState.step === 3 && <PaidAds />}
                            {onboardingState.step === 4 && <Review />}
                            {onboardingState.step === 5 && <Customizations />}
                            {onboardingState.step === 6 ? 
                                (site?.attr?.expediteOnboarding ? <QuestionsComponent /> :
                                <Complete />) : 
                            <></>}
                            {/* {(onboardingState.step === 7 && site?.attr?.expediteOnboarding) && <VideoPresentation />} */}
                            {(onboardingState.step === 8 && site?.attr?.expediteOnboarding) && <Complete />}
                        </div>
                        {onboardingState.step === 1 && nextEnabled && <h4 className="text-center mt-2 alert alert-success">
                            You have chosen your Google Analytics account! Please click next to proceed.
                        </h4>}
                        {onboardingState.step === 2 && nextEnabled && <h4 className="text-center mt-2 alert alert-success">
                            You have made your Social Media account selections! Please click next to proceed.
                        </h4>}
                    </CardBody>
                </Card>
            </div>
        </div>
    </div>
}

export default Onboarding